import { restoreCurrentLoungeUrl } from "./crossAppNavigation";

restoreCurrentLoungeUrl();
